import { __decorate, __metadata, __param } from "tslib";
import { E_CompanyArea, E_CompanyChargeMode } from '@/apis/service/CompanyApi.types';
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { getSelectTimezone } from '@/@core/utils/variables';
import { Countries } from '../libs/countries';
import { E_ChargeMode, E_PackageTag } from '../apis/service/PackageApi.types';
import _ from 'lodash';
let AccountAddTrialService = class AccountAddTrialService {
    constructor(packageApi, companyApi, accountApi, companyOrderService) {
        this.packageApi = packageApi;
        this.companyApi = companyApi;
        this.accountApi = accountApi;
        this.companyOrderService = companyOrderService;
        this.queryCompanies = [];
        this._accountSalesList = [];
        this._queryCompanieslist = [];
        /* 获取试用天数 */
        this.getTrialLimit = this.accountApi.getTrialDaysLimitation;
        /**
         * 根据salesforceId获取公司信息
         */
        this.getCompanyInfoBySalesforceId = this.companyApi.getCompanyInfoBySalesforceId;
        /**
        * 添加试用
        */
        this.postPrivilegeTrial = this.accountApi.postAccountPrivilegeTrial;
        this.postAccountPrivilegeTrialCheck = this.accountApi.postAccountPrivilegeTrialCheck;
        /**
         * 批量添加试用check
         */
        this.postAccountPrivilegeTrialBatchCheck = this.accountApi.postAccountPrivilegeTrialBatchCheck;
        /**
         * 批量添加试用
         */
        this.postAccountPrivilegeTrialBatch = this.accountApi.postAccountPrivilegeTrialBatch;
        this.CompanyChargeModes = [
            E_CompanyChargeMode.TRIAL,
            E_CompanyChargeMode.INTERNAL,
            E_CompanyChargeMode.COOPERATIVE
        ];
        this.CompanyAreas = [
            E_CompanyArea.east,
            E_CompanyArea.west
        ];
    }
    /* 获取国家 */
    get countries() {
        return Countries;
    }
    /* 获取时区 */
    get timezones() {
        return getSelectTimezone();
    }
    get queryCompanieslist() {
        return this._queryCompanieslist;
    }
    getTrialDaysConfig(trialLimit) {
        const daysList = [5, 10, 20, 30, 60, 90, 180, 360, 720];
        const oneTimeLimitation = trialLimit.oneTimeLimitation;
        const defaultDay = oneTimeLimitation < 7 ? oneTimeLimitation : 7;
        const _index = _.findIndex(daysList, (item, index) => {
            return item >= oneTimeLimitation || index === daysList.length - 1;
        });
        const days = _.slice(daysList, 0, _index + 1);
        if (_.last(days) < oneTimeLimitation) {
            days.push(oneTimeLimitation);
        }
        return {
            daysOptions: days,
            defaultDay,
        };
    }
    /**
     * 获取试用package并且加入checked值
     */
    getPackageTrial($canUseDataResource) {
        const betaPermision = $canUseDataResource(E_ChargeMode.BETA);
        return this.packageApi.getPackageByChargeMode(E_ChargeMode.TRIAL).then(data => {
            data = _.filter(data, pkg => {
                const allowType = [E_PackageTag.BASE, E_PackageTag.SUB_INDEPENDENT, E_PackageTag.ADDON];
                /** 只返回 BASE，SUB_INDEPENDENT，ADDON */
                if (!betaPermision && _.includes(pkg.charge_modes, E_ChargeMode.BETA)) {
                    return false;
                }
                if (_.includes(allowType, pkg.package_tag)) {
                    return true;
                }
                else {
                    return false;
                }
            });
            const packagesListOptions = _.map(data, (el) => {
                return {
                    en_name: el.en_name,
                    package_id: el.id,
                    package_name: el.package_name,
                    package_tag: el.package_tag,
                    charge_mode: el.charge_mode,
                    /** 试用默认不选中， 不操作接口的值 */
                    enabled: false,
                    package_types: [],
                    value: el.id,
                    checked: false,
                    isHidden: false,
                };
            });
            return packagesListOptions;
        });
    }
};
AccountAddTrialService = __decorate([
    injectable(),
    __param(0, inject(Symbols.PackageApi)),
    __param(1, inject(Symbols.CompanyApi)),
    __param(2, inject(Symbols.AccountApi)),
    __param(3, inject(Symbols.CompanyOrderService)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], AccountAddTrialService);
export { AccountAddTrialService };
